module.exports = __webpack_public_path__ + "media/Video 77.805c6e4b.mp4";